import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("lpm_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export function formatApiError(err) {
    const d = err?.response?.data?.detail;
    if (!d) return err?.message || "Une erreur est survenue";
    if (typeof d === "string") return d;
    if (Array.isArray(d))
        return d
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    return typeof d.msg === "string" ? d.msg : JSON.stringify(d);
}
